<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
  <a class="navbar-brand" href="#">{{ appName }}</a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" id="navbarText">
    <ul class="navbar-nav mr-auto">
      <li v-if="!user.uid" class="nav-item">
        <a class="nav-link" href="#" v-on:click="showLoginModal">Login</a>
      </li>
      <li v-if="user.uid" class="nav-item active">
         <a class="nav-link" href="#">{{ user.username }}</a>
      </li>
      <li v-if="user.uid" class="nav-item">
        <a class="nav-link" href="#" v-on:click="logout">Logout</a>
      </li>
    </ul>
  </div>
</nav>
</template>

<script>
  export default {
    name: 'app-navbar',
    props: ['user'],
    data (){
      return {
        appName: process.env.VUE_APP_APP_NAME
      }
    },
    mounted: function(){
    },
    methods: {
      showLoginModal: function(){
        this.$emit("showLoginModal")
      },
      logout: function(){
        this.$emit("logout")
      }
    }
  }
</script>
